import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { ToastrService } from 'ngx-toastr';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {

  constructor(private router: Router, private auth: AuthService, private toast: ToastrService) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    console.log();

  /*
   * Validar se o usuário tem um token invalido
   * Validar se a propriedade roles existe e se o usuário tem permissão para acessar.
   */
  if (this.auth.isAccessTokenInvalido()) {
    if (localStorage.getItem('token')) {
      this.toast.error('Sua sessão expirou, faça  login novamente.');
      localStorage.removeItem('token');
    }

    this.router.navigate(['/login']);
    return false;
  } else if (next.data.roles && !this.auth.temQualquerPermissao(next.data.roles)) {
      this.router.navigate(['/nao-autorizado']);
      return false;
  }

    return true;
  }
}
